// src/config.js

const API_BASE_URL = 'https://adminpanel.wesfoeco.com/wesfo-admin-api';
// const API_BASE_URL = 'http://localhost/Bioworld-web/wesfo-admin-api';

export default API_BASE_URL;
